import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const InstallPrompt: React.FC = () => {
    const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
    const [showPrompt, setShowPrompt] = useState(false);
    const [isSafari, setIsSafari] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        console.log("User Agent: " + navigator.userAgent);
        // Check if the user is on a mobile device
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        // Detect Safari on iOS
        // const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && /iPhone|iPad|iPod/i.test(navigator.userAgent);
        // setIsSafari(isSafariBrowser);

        if (!isMobile) {
            return; // Do not show the prompt on desktop
        }

        // if (isSafariBrowser) {
        //     setShowPrompt(true); // Show custom prompt for Safari
        //     return;
        // }

        const handleBeforeInstallPrompt = (e: any) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setShowPrompt(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then(() => {
                setDeferredPrompt(null);
                setShowPrompt(false);
            });
        }
    };

    const handleCloseClick = () => {
        setShowPrompt(false);
    };

    if (!showPrompt) {
        return null;
    }

    return (
        <div style={{ backgroundColor: '#ffcc00', padding: '10px', textAlign: 'center' }}>
            <button
                onClick={handleCloseClick}
                style={{
                    position: 'absolute',
                    top: '5px',
                    right: '10px',
                    background: 'none',
                    border: 'none',
                    fontSize: '16px',
                    cursor: 'pointer',
                }}
                aria-label={t('install_prompt.close')}
            >X</button>
            {isSafari ? (
                <p>
                    {t('install_prompt.safari')}
                </p>
            ) : (
                <>
                    <p>{t('install_prompt.text')}</p>
                    <button onClick={handleInstallClick} style={{ padding: '5px 10px', cursor: 'pointer' }}>
                        {t('install_prompt.button')}
                    </button>
                </>
            )}
        </div>
    );
};

export default InstallPrompt;